import React from 'react';

export function SkeletonLine({ width = '100%', height = 14, style = {} }) {
  return (
    <div className="skeleton" style={{ width, height, borderRadius: '6px', ...style }} />
  );
}

export function SkeletonCard({ style = {} }) {
  return (
    <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e5e5', padding: '14px 16px', ...style }}>
      <SkeletonLine width="50%" height={11} style={{ marginBottom: '8px' }} />
      <SkeletonLine width="40%" height={28} />
    </div>
  );
}

export function SkeletonLista({ linhas = 4 }) {
  return (
    <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e5e5', overflow: 'hidden' }}>
      {Array.from({ length: linhas }).map((_, i) => (
        <div key={i} style={{ padding: '12px 16px', borderBottom: i < linhas - 1 ? '1px solid #f5f5f5' : 'none', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div className="skeleton" style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <SkeletonLine width="40%" height={12} style={{ marginBottom: '6px' }} />
            <SkeletonLine width="60%" height={10} />
          </div>
          <SkeletonLine width={60} height={20} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: '12px', marginBottom: '20px' }}>
        {[1, 2, 3, 4].map(i => <SkeletonCard key={i} />)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
        <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e5e5', padding: '16px' }}>
          <SkeletonLine width="40%" height={14} style={{ marginBottom: '14px' }} />
          {[1,2,3].map(i => <SkeletonLine key={i} width="100%" height={36} style={{ marginBottom: '8px', borderRadius: '8px' }} />)}
        </div>
        <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e5e5', padding: '16px' }}>
          <SkeletonLine width="50%" height={14} style={{ marginBottom: '14px' }} />
          {[1,2,3,4].map(i => (
            <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
              <div className="skeleton" style={{ width: 22, height: 22, borderRadius: '50%' }} />
              <SkeletonLine width="60%" height={12} />
              <SkeletonLine width={50} height={12} style={{ marginLeft: 'auto' }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
